import React from 'react'
import { bool, string, func } from 'prop-types'
import { cx } from '@emotion/css'
import { Flag, BadgeButton, colors } from '@offerzen/pinata'
import PencilIcon from '@offerzen/zenicon/PencilIcon'
import QuestionIcon from '@offerzen/zenicon/QuestionIcon'
import TrashIcon from '@offerzen/zenicon/TrashIcon'

import AccessibleIcon from '../../../../../CandidateExperience/components/AccessibleIcon'
import CITIZENSHIP_STATUS_LIST from '../../../../../CandidateExperience/constants/citizenshipStatusList'

import styles from './styles'

const WorkAuthPreview = props => {
  const status = CITIZENSHIP_STATUS_LIST.find(i => i.id === props.citizenshipStatus)
  return (
    <div className={styles.wrapper}>
      <Choose>
        <When condition={props.countryIso2Code}>
          <Flag countryCode={props.countryIso2Code} className={cx(styles.flag, styles.row)} />
        </When>
        <Otherwise>
          <AccessibleIcon icon={QuestionIcon} className={cx(styles.unknown, styles.row)} color={colors.black} size={12} />
        </Otherwise>
      </Choose>

      <h3 className={cx(styles.title, styles.row)}>{props.countryName || 'No country specified'}</h3>

      <div className={styles.status}>{status && status.label}</div>

      <BadgeButton icon={PencilIcon} theme="primary" onClick={() => props.toggleFieldSection(true)} className={styles.editButton} />
      <BadgeButton
        icon={TrashIcon}
        theme="primary"
        disabled={props.isDeletingCitizenship}
        onClick={() =>
          props.deleteCitizenship({
            id: props.workAuthId,
            countryName: props.countryName,
            citizenshipStatus: props.citizenshipStatus,
          })
        }
        className={styles.deleteButton}
      />

      <If condition={props.citizenshipStatus && props.citizenshipStatus.toLowerCase() === 'work_permit' && props.permitType}>
        <div className={styles.permitType}>
          <span className={styles.semiBold}>Type: </span>
          {props.permitType}
        </div>
      </If>
    </div>
  )
}

WorkAuthPreview.propTypes = {
  workAuthId: string,
  countryIso2Code: string,
  countryName: string,
  citizenshipStatus: string,
  toggleFieldSection: func,
  permitType: string,
  isDeletingCitizenship: bool,
  deleteCitizenship: func,
}
export default WorkAuthPreview
